import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAuditLogUpsellViewed.meta';

export type UseTrackAuditLogUpsellViewedParams = {
  plan_name: string;
  workspace_id: string;
};

export const useTrackAuditLogUpsellViewed = () => {
  const { track } = useAnalyticsUtilities();

  const trackAuditLogUpsellViewed = useCallback(
    (params: UseTrackAuditLogUpsellViewedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAuditLogUpsellViewed };
};
